import { RichText } from 'prismic-reactjs';
import React from 'react';
import { Link } from 'react-router-dom';
import bg from '../../assets/topo-blue-pattern.png';
import { ContentWrapper } from '../../components/content_wrapper/content_wrapper';
import PrismicSingleLoader from '../../components/prismic_single_loader/prismic_single_loader';
import { ScrollToTop } from '../../components/scroll_to_top/scroll_to_top';
import { SEO } from '../../components/seo/seo';
import { serializeHyperlink } from '../../lib/serializers';
import { linkResolver, PrismicDocumentTypes } from '../../prismic';
import { RoutePaths } from '../../routes';
import styles from './shipping_returns_page.less';

export const DeliveryReturnPage = () => {
  return (
    <ScrollToTop>
      <section>
        <SEO title="Shipping &amp; Returns" />
        <header style={{ backgroundImage: `url(${bg})` }}>
          <ContentWrapper>
            <h1 className={styles.h1}>Shipping &amp; Returns</h1>
          </ContentWrapper>
          <ContentWrapper noPadding>
            <ul className={styles.features}>
              <li className={styles.feature}>
                <div className={styles.featureContent}>
                  <strong className={styles.featureHighlight}>$5 Flat Rate</strong>
                  on orders under $50
                </div>
              </li>
              <li className={styles.feature}>
                <div className={styles.featureContent}>
                  <strong className={styles.featureHighlight}>FREE SHIPPING</strong>
                  on orders over $50
                </div>
              </li>
              <li className={styles.feature}>
                <div className={styles.featureContent}>
                  <strong className={styles.featureHighlight}>FREE SHIPPING</strong>
                  <span className={styles.blue}>no minimum with Omnia PRO</span>
                  <Link to={RoutePaths.PREMIUM_PRO} className={styles.featureLink}>
                    Upgrade Now ›
                  </Link>
                </div>
              </li>
            </ul>
          </ContentWrapper>
        </header>

        <ContentWrapper>
          <article className={styles.article}>
            <PrismicSingleLoader
              type={PrismicDocumentTypes.SHIPPING}
              render={(page) => {
                return (
                  <>
                    {page.body.map((slice, i) => {
                      switch (slice.slice_type) {
                        case 'text': {
                          return (
                            <RichText
                              key={`${slice.primary.text[0].text}:${slice.primary.text.length}`}
                              render={slice.primary.text}
                              linkResolver={linkResolver as any}
                              serializeHyperlink={serializeHyperlink as any}
                            ></RichText>
                          );
                        }
                        case 'raw_html': {
                          return (
                            <div
                              dangerouslySetInnerHTML={{ __html: slice.primary.html }}
                              key={`${slice.slice_type}${i}`}
                            />
                          );
                        }
                      }
                    })}
                  </>
                );
              }}
            ></PrismicSingleLoader>
          </article>
        </ContentWrapper>
      </section>
    </ScrollToTop>
  );
};

export default DeliveryReturnPage;
